import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toggle',
  templateUrl: './app-toggle.component.html',
  styleUrls: ['./app-toggle.component.scss'],
  standalone: false,
})
export class ToggleComponent implements OnInit {
  @Input() public isEditMode = false;

  @Input() public options: string[] = [];

  @Input() public actifOption: string = '';

  @Input() public showBorder: boolean = false;

  @Input() public showBorderBottom: boolean = false;

  @Input() public equalColumnsWidth: boolean = false;

  @Input() public bubbleDesign: boolean = false;

  @Output() public onOptionClick = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {
    if (this.options.length === 1) {
      this.equalColumnsWidth = false;
    }
  }

  optionClickHandler(option: string) {
    this.onOptionClick.emit(option);
  }
}
